import { useQuery } from '@tanstack/react-query'
import request from 'superagent'
import { fetchPricesApi } from '../api/fetch-prices-api'

async function fetchPricesQuery() {
  return await request.get(fetchPricesApi)
}

export const fetchPrices = () => {
  return useQuery({ queryKey: ['prices'], queryFn: fetchPricesQuery, refetchOnWindowFocus: false, retry: false })
}